import React, { useState } from 'react';
import { Checkbox } from "antd";;

function TermsCheckbox({ isEmailEnglishLanguage = true, checked, onChange }) {
    

    const termsText = isEmailEnglishLanguage === false
        ? 'Eu consinto expressamente o processamento da informação pessoal acima preenchida ou anexada por mim em documentos, de acordo com a '
        : 'I explicitly agree to the processing of all the above personal data, that have been filled in or attached as a document by me, in accordance with the '

    const termsText2 = isEmailEnglishLanguage === false
        ? ' da Adentis'
        : ' of Adentis '
    const linkText = isEmailEnglishLanguage === false
        ? 'Política de Privacidade'
        : 'Privacy Policy'

    const link = isEmailEnglishLanguage === false
        ? 'https://www.adentis.pt/pt/politica/privacidade'
        : 'https://www.adentis.pt/en/policy/policies'

    return (
        <Checkbox
            defaultChecked={checked}
            className="questionTextFormat"
            onChange={onChange}
        >
            {' '}
            {termsText}
            <a href={link} target="_blank" rel="noopener noreferrer">
                {linkText}
            </a>
            {termsText2}
        </Checkbox>
        //<label>
        //    <input
        //        type="checkbox"
        //        checked={checked}
        //        onChange={(e) => setChecked(e.target.checked)}
        //    />
        //    {' '}
        //    {termsText}
        //    <a href="/terms" target="_blank" rel="noopener noreferrer">
        //        {linkText}
        //    </a>
        //</label>
    );
};

export default TermsCheckbox;